import { Component } from '@angular/core';
import { BaseTechnicalSectionComponent } from '../../common/base-technical-section.component';
import { EnvironmentService } from 'src/app/services/environment.service';
import { TechnicalSpecificationsFormSections } from 'src/app/+grid-application-shared/entities/enums/ui-collection-types.enum';
import { GridApplicationCommentsService } from 'src/app/+grid-application-shared/services/grid-application-comments.service';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-meter-operation',
  templateUrl: './meter-operation.component.html',
  styleUrls: ['./meter-operation.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class MeterOperationComponent extends BaseTechnicalSectionComponent {
  constructor(commentService: GridApplicationCommentsService, environmentService: EnvironmentService) {
    super(commentService, environmentService);
  }

  get formSection(): TechnicalSpecificationsFormSections {
    return TechnicalSpecificationsFormSections.MeterOperation;
  }

  protected get sectionComment(): string | null {
    return this.technicalData.technical_specifications_sections_state?.meter_operation_comment;
  }

  protected set sectionComment(value: string | null) {
    this.technicalData.technical_specifications_sections_state.meter_operation_comment = value;
  }

  protected get sectionLocked(): boolean | null {
    return this.technicalData.technical_specifications_sections_state?.is_meter_operation_locked;
  }

  protected set sectionLocked(value: boolean | null) {
    this.technicalData.technical_specifications_sections_state.is_meter_operation_locked = value;
  }
}
